module.exports = __webpack_public_path__ + "static/media/excited-lively.31e0b877.png";